const system = {
  loading: "Проверка изоляции пользовательских данных приложения…",
  unavailable: {
    title: "Состояние системы недоступно",
    retry: "Повторить",
    fetchFailed: "Не удалось получить состояние системы.",
    healthFailed: "Проверка состояния системы завершилась ошибкой.",
  },
  header: {
    title: "Архитектура и состояние системы",
    description: "Эта страница относится ко всей системе и доступна только Super-Admin. Она проверяет, что каждая запись приложения — источники, фильтры, настройки ИИ, отслеживаемые публикации, состояние Inbox и назначения — принадлежит одному участнику. Учётные данные по-прежнему управляются в личном разделе My Destinations каждого участника.",
    scope: "Область системного администрирования",
    notice: "Уведомление о состоянии системы",
    cutoverTitle: "Переход к полному владению данными ещё не завершён",
    cutoverDescription: "Требуется согласованный релиз базы данных и backend, прежде чем для каждого источника, фильтра, параметра ИИ, отслеживаемой публикации, элемента Inbox и назначения наличие владельца станет обязательным на уровне структуры.",
    supabaseEndpoint: "Endpoint Supabase:",
    notConfigured: "Не настроен",
    refresh: "Обновить состояние",
  },
  overview: {
    backendLabel: "Backend",
    backendTitle: "Нормализованный PostgreSQL",
    backendActive: "Backend активен",
    backendUnavailable: "Backend недоступен",
    architectureLabel: "Многопользовательская архитектура",
    architectureTitle: "Изоляция рабочих пространств",
    isolated: "Личные данные изолированы",
    cutoverIncomplete: "Переход не завершён",
    automationLabel: "Автоматизация",
    automationTitle: "Сбор и очистка",
    jobsActive: "Задания активны",
    automationIncomplete: "Автоматизация не завершена",
    securityLabel: "Безопасность данных",
    securityTitle: "Таблицы под контролем backend",
    protected: "{{protected}}/{{expected}} защищено",
  },
  monitoring: {
    title: "Личные данные мониторинга",
    description: "Источники и собранные публикации Telegram хранятся отдельно для каждого участника, даже если два участника отслеживают один публичный канал.",
    sourceChannels: "Каналы-источники",
    monitoredPosts: "Отслеживаемые публикации · 24 ч",
  },
  workspace: {
    title: "Данные личного рабочего пространства",
    description: "Workflow Inbox и конфигурация публикации также разделяются по владельцу. Счётчики ниже — только агрегированные показатели состояния системы.",
    destinationTargets: "Назначения",
    inboxRows: "Строки workflow Inbox",
    publishedWorkflow: "Опубликованные состояния",
    supabaseMembers: "Участники Supabase",
    legacyMembers: "Legacy-участники",
    unownedRows: "Строки без владельца",
    publishStates: "Персональные состояния публикации",
    durableIdentities: "Активные постоянные идентичности",
    usernameOwned: "Пространства, принадлежащие username",
    shouldRemainZero: "Должно оставаться 0",
    owners_one: "{{formattedCount}} владелец",
    owners_few: "{{formattedCount}} владельца",
    owners_many: "{{formattedCount}} владельцев",
    owners_other: "{{formattedCount}} владельца",
  },
  runtime: {
    title: "Границы данных runtime",
    description: "Все таблицы приложения персональные. Только legacy-запись совместимости является системной, а браузерные клиенты не получают прямого доступа на запись в базу данных.",
    scopes: { personal: "Персональные", compatibility: "Совместимость" },
    tables: {
      source_channels: "Личные источники",
      filters: "Личные фильтры",
      destination_targets: "Личные назначения",
      ai_settings: "Личные настройки ИИ",
      posts: "Личные отслеживаемые публикации",
      user_inbox_items: "Личное состояние Inbox",
      curator_settings: "Legacy-совместимость",
    },
  },
  isolation: {
    title: "Проверки изоляции рабочих пространств",
    description: "Эти проверки подтверждают, что данные приложения не могут существовать вне рабочего пространства участника.",
    ownershipTitle: "Полное владение данными приложения",
    ownershipDescription: "Источники, фильтры, настройки ИИ, публикации и назначения должны иметь владельца.",
    inboxTitle: "Изоляция Content Inbox",
    inboxDescription: "Состояние проверки/редактирования/публикации связывается только с публикациями того же владельца.",
    orphanTitle: "Проверка данных без владельца",
    orphanDescription: "Каждая производственная строка приложения должна иметь владельца.",
    ready: "Готово",
    missing: "Отсутствует",
    cutoverPending: "Переход ожидается",
    noOrphans: "Нет данных без владельца",
    unowned: "{{count}} без владельца",
    note: "Определения источников, фильтры, настройки ИИ, текст отслеживаемых публикаций, статусы, история и ошибки никогда не считаются глобальной конфигурацией. Токены Telegram-ботов остаются в пользовательских секретах Vault.",
  },
  automation: {
    title: "Автоматизация сбора",
    description: "Планировщик перечисляет владельцев с включёнными источниками и запускает сбор в каждом изолированном пространстве, используя фильтры и записи публикаций этого участника.",
    cronInstalled: "pg_cron установлен",
    cronMissing: "pg_cron отсутствует",
    netInstalled: "pg_net установлен",
    netMissing: "pg_net отсутствует",
    empty: "Задания сбора TGReposter не найдены.",
    jobs: { import: "Импорт Source Inbox", cleanup: "Периодическая очистка Inbox" },
    schedules: { everyFiveMinutes: "Каждые 5 минут", everyHour: "Каждый час" },
    succeeded: "Успешно",
    active: "Активно",
    lastRunFailed: "Последний запуск завершился ошибкой",
    disabled: "Отключено",
    lastRun: "Последний запуск: {{time}}",
    noRun: "Запуски не зарегистрированы",
  },
  security: {
    title: "Runtime под управлением миграций и с безопасностью по умолчанию",
    description: "Структурные изменения версионируются через миграции Supabase. Вся конфигурация приложения и контент принадлежат участникам, а чувствительные операции записи выполняются аутентифицированными backend-маршрутами, а не напрямую из браузера.",
  },
} as const;

export default system;
